import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Paper,
  Typography,
  Skeleton,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Pagination,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { fetchAllBatches } from '../../../../Reducer/productBatchesSlice';
import dayjs from 'dayjs';

export const AllBatches = () => {
  const dispatch = useDispatch();
  const { allBatchesData: data, allBatchesLoading: loading, allBatchesError: error, allBatchesMetadata: productBatchesMetadata } = useSelector((state) => state.productBatches);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    dispatch(fetchAllBatches({ page, limit: 10 }));
  }, [dispatch, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (productBatchesMetadata && productBatchesMetadata.totalPages) {
      setTotalPages(productBatchesMetadata.totalPages);
    }
  }, [productBatchesMetadata]);

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Error: {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: isMobile ? 1 : 3 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{
        fontWeight: 600,
        mb: 3,
        color: theme.palette.primary.main
      }}>
        All Batches
      </Typography>

      <Paper elevation={2} sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader aria-label="batches table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Exhibitors</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Product ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Variant ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Available</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Deficient</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Event</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.light', color: 'white' }}>Variant</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                // Loading skeletons
                Array.from(new Array(10)).map((_, index) => (
                  <TableRow key={index}>
                    {Array.from(new Array(10)).map((_, cellIndex) => (
                      <TableCell key={cellIndex}>
                        <Skeleton variant="text" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                // Actual data
                data.length > 0 ? data.map((batch) => (
                  <TableRow
                    key={batch.id}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'action.hover'
                      }
                    }}
                  >
                    <TableCell>{batch.id}</TableCell>
                    <TableCell>{batch.exhibitors_count}</TableCell>
                    <TableCell>{batch.product_id}</TableCell>
                    <TableCell>{batch.product_variant_id || 'N/A'}</TableCell>
                    <TableCell>{batch.product_type}</TableCell>
                    <TableCell>
                      <Chip
                        label={batch.deliveryStatus}
                        size="small"
                        color={
                          batch.deliveryStatus === 'Delivered' ? 'success' :
                            batch.deliveryStatus === 'Processing' ? 'warning' :
                              'default'
                        }
                      />
                    </TableCell>
                    <TableCell>{batch.available_count}</TableCell>
                    <TableCell>
                      <Chip
                        label={batch.deficiate_count}
                        size="small"
                        color={batch.deficiate_count > 0 ? 'error' : 'success'}
                        variant={batch.deficiate_count > 0 ? 'filled' : 'outlined'}
                      />
                    </TableCell>
                    <TableCell>{batch.product?.event_name}</TableCell>
                    <TableCell>{batch.variant?.name || 'N/A'}</TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      No batches found.
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            disabled={loading || loading === undefined}
          />
        </Box>
      </Paper>
    </Box>
  );
};